<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-left">
        <div class="welcome-text">
          <h1>Welcome Back!</h1>
          <p>TT短信收发管理平台</p>
        </div>
        <div class="illustration">
          <!-- 可以添加一个SVG图标或图片 -->
          <img src="@/assets/message.svg" alt="messaging illustration"/>
        </div>
      </div>
      <div class="login-right">
        <div class="login-form">
          <div class="form-header">
            <img src="@/assets/logo.png" alt="logo" class="about-logo">
            <h2>用户登录</h2>
            <p>请输入您的账号和密码</p>
          </div>
          <form @submit.prevent="handleLogin">
            <div class="form-item">
              <label>用户名</label>
              <div class="input-with-icon">
                <i class="el-icon-user"></i>
                <input
                  v-model="loginForm.username"
                  type="text"
                  placeholder="请输入用户名"
                  required
                />
              </div>
            </div>
            <div class="form-item">
              <label>密码</label>
              <div class="input-with-icon">
                <i class="el-icon-lock"></i>
                <input
                  v-model="loginForm.password"
                  type="password"
                  placeholder="请输入密码"
                  required
                />
              </div>
            </div>
            <div class="form-item remember-forgot">
              <label class="remember">
                <input type="checkbox" v-model="rememberMe"/>
                <span>记住我</span>
              </label>
              <a href="#" class="forgot-password">忘记密码？</a>
            </div>
            <div class="form-item">
              <button type="submit">登 录</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rememberMe: false
    }
  },
  methods: {
    handleLogin() {
      this.$http.post('/common/user/login', this.loginForm)
      .then(res => {
        if (res.code === 200) {
          this.$message.success('登录成功')
          localStorage.setItem('token', res.token)
          if (this.rememberMe) {
            localStorage.setItem('credentials', JSON.stringify({
              username: this.loginForm.username,
              password: window.btoa(this.loginForm.password)
            }))
          } else {
            localStorage.removeItem('credentials')
          }
          this.$router.push('/chat')
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    const savedCredentials = localStorage.getItem('credentials')
    if (savedCredentials) {
      try {
        const credentials = JSON.parse(savedCredentials)
        this.loginForm.username = credentials.username
        this.loginForm.password = window.atob(credentials.password)
        this.rememberMe = true
      } catch (e) {
        localStorage.removeItem('credentials')
      }
    }
  },
  beforeDestroy() {
    if (!this.rememberMe) {
      localStorage.removeItem('credentials')
    }
  }
}
</script>

<style scoped>
.about-logo {
  width: 60px;
}
.login-container {
  height: 100vh;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #344CB7 0%, #577BC1 100%);
}

.login-box {
  width: 900px;
  height: 600px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  overflow: hidden;
}

.login-left {
  flex: 1;
  background: linear-gradient(135deg, #577BC1 0%, #344CB7 100%);
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}

.welcome-text {
  text-align: center;
  margin-bottom: 40px;
}

.welcome-text h1 {
  font-size: 36px;
  margin-bottom: 10px;
}

.welcome-text p {
  font-size: 18px;
  opacity: 0.9;
}

.illustration {
  width: 80%;
  max-width: 300px;
}

.illustration img {
  width: 100%;
  height: auto;
}

.login-right {
  flex: 1;
  padding: 40px;
  display: flex;
  align-items: center;
}

.login-form {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
}

.form-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.form-header p {
  color: #666;
  font-size: 14px;
}

.form-item {
  margin-bottom: 20px;
}

.form-item label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.input-with-icon {
  position: relative;
}

.input-with-icon i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
}

.input-with-icon input {
  width: 80%;
  padding: 12px 12px 12px 40px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s;
}

.input-with-icon input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.remember {
  display: flex;
  align-items: center;
  color: #666;
}

.remember input[type="checkbox"] {
  margin-right: 6px;
}

.forgot-password {
  color: #667eea;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

button:hover {
  transform: translateY(-1px);
  box-shadow: 0 7px 14px rgba(0, 0, 0, 0.1);
}

button:active {
  transform: translateY(1px);
}
</style>
